/* global axios */

const DEFAULT_API_VERSION = 'v1';

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const isInsideAccountScopedURLs = window.location.pathname.includes(
      '/app/accounts'
    );

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl() {
    let url = this.apiVersion;

    if (this.options.enterprise) {
      url = `/enterprise${url}`;
    }

    if (this.options.accountScoped && this.accountIdFromRoute) {
      url = `${url}/accounts/${this.accountIdFromRoute}`;
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data, config) {
    return axios.post(this.url, data, config);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
  getdata(id){
    return axios.get(`${this.url}/${id}`);
  }
  getall(){
    return axios.get(`${this.url}`);
  }
  deletetrigger(labelId,triggerId){
    return axios.delete(`${this.url}/${labelId}/delete_trigger/${triggerId}`);    
  }
  // getstate() {
  //   console.log("Get state data");
  //   return axios.get(`https://pipeline-crm.loca.lt/api/v1/accounts/1/fetch_states`, {
  //     headers: {
  //       Authorization: 'iAx37WyKm77P9J1bLEYv6Bd9', // Pass your header here
  //     },
  //   });
  // }
}

export default ApiClient;
